import React, { useState } from 'react';
import './ForgotPasswordPage.css';

function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    const res = await fetch(`${process.env.REACT_APP_API_URL}/api/users/send-reset-password`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email }),
    });

    if (res.ok) {
      setMessage('Te hemos enviado un correo para cambiar tu contraseña.');
    } else {
      setMessage('Correo no registrado.');
    }
  };

  return (
    <div className="forgot-password-container">
      <h2>¿Olvidaste tu contraseña?</h2>
      <form onSubmit={handleSubmit} className="forgot-password-form">
        <input 
          type="email" 
          placeholder="Introduce tu correo"
          value={email}
          onChange={(e) => setEmail(e.target.value)} 
          required 
        />
        <button type="submit">Enviar enlace</button>
      </form>
      {message && <p className="message">{message}</p>}
    </div>
  );
}

export default ForgotPasswordPage;
